import ReactHtmlParser from "react-html-parser";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/pro-duotone-svg-icons";
import type ArticleReference from "@/src/_types/Article/article-reference";

const ArticleReferences = (
    {
        references
    }: {
        references: ArticleReference[]
    }
) => {
    if (!references) return null;

    return (
        <Box
            component="section"
            role="doc-bibliography"
        >
            <Typography
                component="h3"
                color="textSecondary"
                sx={{ marginBlockEnd: 0, marginBottom: 0 }}
            >
                <SpanTypography mr={.25}>
                    <FontAwesomeIcon
                        icon={faArrowUpRightFromSquare}
                    />
                </SpanTypography>
                <SpanTypography fontSize={'1.5rem'}>
                    References
                </SpanTypography>
            </Typography>
            <List sx={{ 
                py: 0,
                '& a': {
                    overflowWrap: 'break-word',
                    wordBreak: 'break-all'
                } 
            }}>
                {
                    references.map((ref: ArticleReference) => (
                        ( ref.ref_html && ref.ref_html !== '' ) &&
                        <ListItem
                            key={ref.id}
                            id={ref.id}
                            sx={{
                                display: 'flex',
                                alignItems: 'baseline',
                                paddingTop: 0,
                                paddingBottom: 0,
                                textAlign: 'justify',
                                'span': {
                                    fontSize: '.9rem'
                                }
                            }}
                        >
                            <SpanTypography
                                variant="body2"
                                fontStyle="italic"
                                mr={.25}
                            >
                                {ref.label}.
                            </SpanTypography>
                            <ListItemText>
                                <Box>
                                    {
                                        ReactHtmlParser(ref.ref_html)
                                    }
                                </Box>
                            </ListItemText>
                        </ListItem>
                    ))
                }
            </List>
        </Box>
    );
}

export default ArticleReferences;